import { Example, ExampleFilters } from "./Example";
import { useTranslation } from "react-i18next";

import styles from "./Example.module.css";

interface ExampleWithFilters {
    text: string;
    filters?: ExampleFilters;
}

interface Props {
    onExampleClicked: (value: string, filters?: ExampleFilters) => void;
    useGPT4V?: boolean;
}

export const ExampleList = ({ onExampleClicked, useGPT4V }: Props) => {
    const { t } = useTranslation();

    // Default examples without pre-selected filters
    const DEFAULT_EXAMPLES: ExampleWithFilters[] = [
        {
            text: t("defaultExamples.1")
        },
        {
            text: t("defaultExamples.2")
        },
        {
            text: t("defaultExamples.3")
        }
    ];

    // GPT4V examples without pre-selected filters
    const GPT4V_EXAMPLES: ExampleWithFilters[] = [
        {
            text: t("gpt4vExamples.1")
        },
        {
            text: t("gpt4vExamples.2")
        },
        {
            text: t("gpt4vExamples.3")
        }
    ];

    const examples = useGPT4V ? GPT4V_EXAMPLES : DEFAULT_EXAMPLES;

    return (
        <ul className={styles.examplesNavList}>
            {examples.slice(0, 3).map((example, i) => (
                <li key={i}>
                    <Example
                        text={example.text}
                        value={example.text}
                        filters={example.filters}
                        onClick={onExampleClicked}
                    />
                </li>
            ))}
        </ul>
    );
};
